import { Gavel } from "lucide-react";
import useSWR from "swr";

import { InfoSection } from "./components/InfoSection";
import { type IRule } from "./InfoText";

export const InfoRules = () => {
  const {
    data: meta,
    error,
    isLoading,
  } = useSWR<{ rules: IRule[] }>("/api/info");

  return (
    <InfoSection icon={Gavel} title="Rules">
      {isLoading
        ? "Loading"
        : error || (
            <>
              <ol className="list-decimal text-default-800 ml-10 flex flex-col gap-1">
                {meta?.rules.map((rule) => (
                  <li key={rule.id}>
                    <p>{rule.name}</p>
                    {rule.description && (
                      <p className="text-xs text-default-600">
                        {rule.description}
                      </p>
                    )}
                  </li>
                ))}
              </ol>
              <p className="text-default-600 ml-3 mt-1">
                This canvas is built upon good faith rules, therefore moderators
                have complete discretion on the rules. If you have any
                questions, ask in the Matrix space or the Discord
              </p>
            </>
          )}
    </InfoSection>
  );
};
